import { constant } from 'lodash/fp';

export const metaInitialState = {
    hasFailed: false,
    isFetching: false,
};

export const setMetaStarted = constant({
    hasFailed: false,
    isFetching: true,
});

export const setMetaSucceeded = constant({
    hasFailed: false,
    isFetching: false,
});

export const setMetaFailed = constant({
    hasFailed: true,
    isFetching: false,
});
